// extracted by mini-css-extract-plugin
export default {"fab":"expense_fab__Mkklr","filter":"expense_filter__qJq2B","transaction":"expense_transaction__dA44m","sliderContainer":"expense_sliderContainer__5955D"};